<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="90px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="内容标题" prop="title">
            <el-input v-model="queryParams.title" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="queryParams.status"
              placeholder="请选择"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="dict in statusList"
                :key="dict.value"
                :label="dict.name"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="7">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-"
                            style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :md="12" :lg="6" :offset="18">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" @click="handleAdd">添加案例</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" :disabled="multiple" @click="batchOnline">上线</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" :disabled="multiple"  @click="batchOffline">下线</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="dataList" @cell-dblclick="dbClick" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="内容标题" min-width="150" align="center" prop="title" />
      <el-table-column label="封面图" min-width="100" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 60px; height: 60px"
            :src="scope.row.headPicUrl"
            :preview-src-list="[scope.row.headPicUrl]"
            fit="contain"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="排序" min-width="90" align="center" prop="tenantSortNo">
        <template slot="header">
          排序
          <el-popover ref="popover" placement="top" width="180" trigger="hover">
            <div>
              双击单元格可修改排序值<br>
              数值小的排在前面<br>
            </div>
          </el-popover>
          <i v-popover:popover class="el-icon-info"></i>
        </template>
        <template slot-scope="scope">
          <span v-if="!scope.row.tenantSortNoEdit">{{scope.row.tenantSortNo}}</span>
          <el-input-number v-focus v-if="scope.row.tenantSortNoEdit" v-model="scope.row.tenantSortNo"
                           style="width: 100%" :min="0" :max="2147483647" @blur="tenantSortNoBlur(scope.row)" :controls="false"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="100" align="center" prop="statusStr" />
      <el-table-column label="创建时间" min-width="170" align="center" prop="createTime" />
      <el-table-column label="操作" min-width="130" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
          <el-button
            type="text"
            @click="handleChangeStatus(scope.row)"
            v-if="scope.row.status === 1"
          >下线</el-button>
          <el-button
            type="text"
            @click="handleChangeStatus(scope.row)"
            v-if="scope.row.status === 2"
          >上线</el-button>
          <el-button
            type="text"
            @click="handleDelete(scope.row)"
            v-if="scope.row.status === 2"
          >删除</el-button>
          <el-button
            type="text"
            @click="handleEdit(scope.row)"
            v-if="scope.row.status === 2"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryArticleList"
    />
    <AddCaseDialog ref="addProductDialogRef" @success="getList"></AddCaseDialog>
  </div>
</template>

<script>
import {
  queryArticleList,
  changeStatusArticle,
  batchChangeStatus,
  articleDelete,
  articleDetail, changeArticleTenantSortNo
} from "@/api/saas/package";
import AddCaseDialog from "./components/addCaseDialog";

export default {
  name: "BusinessList",
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      total: 1,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        articleType: 2,
        createTime: [],
        createTimeStart: '',
        createTimeEnd: ''
      },
      statusList: [{
        value: 1,
        name: '已上线'
      },{
        value: 2,
        name: '已下线'
      }],
      dataList: [],
      // 非多个禁用
      multiple: true,
      selection: [],
    };
  },
  created() {
    this.queryArticleList();
  },
  components: {
    AddCaseDialog
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.getList();
    },
    handleSee(row) {
      this.$router.push({
        path: "/briefcase/case/detail",
        query: {
          id: row.articleId
        }
      });
    },
    handleChangeStatus(row) {
      changeStatusArticle({
        articleId: row.articleId,
        status: row.status === 2 ? 1 : 2
      }).then(response => {
          this.queryArticleList();
          this.msgSuccess("案例状态更新成功");
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 删除文章
    handleDelete(row) {
      let that = this;
      this.$confirm("是否确认删除该案例?", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(function() {
          that.delete(row);
        })
        .then(() => {});
    },
    delete(row) {
      articleDelete({
        articleId: row.articleId
      })
        .then(response => {
          this.queryArticleList();
          this.msgSuccess("案例删除成功");
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 编辑文章
    handleEdit(row){
      articleDetail({ articleId: row.articleId })
        .then(response => {
          this.$refs.addProductDialogRef.open(response.data);
        })
        .catch(error => {});
    },
    handleAdd() {
      this.$refs.addProductDialogRef.open();
    },
    getList() {
      this.queryParams.pageNum = 1;
      this.queryArticleList();
    },
    queryArticleList() {
      this.loading = true;
      if(this.queryParams.createTime && this.queryParams.createTime.length) {
        this.queryParams.createTimeStart = this.queryParams.createTime[0]
        this.queryParams.createTimeEnd = this.queryParams.createTime[1]
      } else {
        this.queryParams.createTimeStart = null
        this.queryParams.createTimeEnd = null
      }
      queryArticleList(this.queryParams)
        .then(response => {
          let rows = response.rows || []
          rows.forEach(item => {
            item.originalTenantSortNo = item.tenantSortNo
            item.tenantSortNoEdit = false
          })
          this.dataList = rows
          this.total = response.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dbClick (row, column, cell, event) {
      if (column.label === '排序') {
        row.tenantSortNoEdit = true
      }
    },
    tenantSortNoBlur (row) {
      row.tenantSortNoEdit = false
      if (row.originalTenantSortNo === row.tenantSortNo) {
        return
      }
      const loading = this.$loading({lock: true, text: '修改中', spinner: 'el-icon-loading'});
      changeArticleTenantSortNo({
        articleId: row.articleId,
        tenantSortNo: row.tenantSortNo
      }).then(response => {
        this.msgSuccess("修改成功")
        this.queryArticleList();
      }).finally(() => {
        loading.close()
      })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection;
      this.multiple = !selection.length;
    },
    batchOnline(){
      this.$confirm('确认批量修改状态吗？', '提示', {confirmButtonText: '确认'}).then(() => {
        this.selection.forEach(item => item.status=1);//1上线，2下线
        batchChangeStatus(this.selection).
        then(response => {
          this.msgSuccess("上线成功")
          this.queryArticleList();
        }).catch(error => {
          this.loading = false;
        });
      }).catch(() => {
      });
    },
    batchOffline(){
      this.$confirm('确认批量修改状态吗？', '提示', {confirmButtonText: '确认'}).then(() => {
        this.selection.forEach(item => item.status=2);//1上线，2下线
        batchChangeStatus(this.selection).
        then(response => {
          this.msgSuccess("下线成功")
          this.queryArticleList();
        }).catch(error => {
          this.loading = false;
        });
      }).catch(() => {
      });
    }
  }
};
</script>
